import dayjs from 'dayjs';
import { useFormikContext } from 'formik';
import React, { useCallback, useMemo, useState } from 'react';
import { CalendarInput } from 'ui';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import useGetFormGeneratorItemError from '../hooks/useGetFormGeneratorItemError';
import './Date.css';

const Date = props => {
  const { data, onChange, disabled, isBuilder, value, readOnly } = props;
  const { placeholder, type, id, label } = data;
  const { requiredError } = useGetFormGeneratorItemError(id);
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleChange = useCallback(
    date => {
      onChange(type, id, date ? date.toISOString() : null);
    },
    [type, id, onChange],
  );

  const handleLabelChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  const resolveValue = useMemo(() => {
    return dayjs(value || null).isValid() ? dayjs(value) : undefined;
  }, [value]);

  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div className="font-semibold">
        <InlineEdit
          value={label}
          onChange={handleLabelChange}
          fieldName="label"
          isEditing={isEditing}
          onSetIsEditing={setIsEditing}
          readOnly={readOnly}
        />
      </div>
      <div className="date-picker-wrapper">
        <CalendarInput
          className="[&>div]:!px-1 [&>div]:rounded"
          value={resolveValue}
          placeholder={placeholder}
          disabled={disabled || isBuilder}
          onChange={handleChange}
        />
        {requiredError && <div style={{ color: 'red', marginTop: 4 }}>This field is required</div>}
      </div>
    </FormElementWrapper>
  );
};

export default Date;
